$('.table-frame').find('.frame').height($('.table-frame').find('.table.main').height());

$('.close-table').on('click', function () {
    $('.table-frame').fadeOut();
});

let slyOption = {
    horizontal: true,
    itemNav: 'basic',
    speed: 300,
    mouseDragging: 1,
    touchDragging: 1,
    scrollBar: '.scrollbar',
    dragHandle: true,
    dynamicHandle: true,
    smart: 1,
    releaseSwing: 1,
    startAt: 0,
    scrollBy: 1,
    elasticBounds: 1,
    clickBar: 1,
    nextPage: '.table-next'
};

if ($(window).width() > 767) {
    if ($('.frame .slidee').find('.table').length > 3) {
        $('.table-next, .scrollbar').show(0);
        $('.table.main').css({background: ''});
        $('.frame').sly(slyOption, {
            load: function () {
                $('.slidee').width($('.slidee').width() + 2);
            }
        });
    } else {
        $('.table-next, .scrollbar').hide(0);
        $('.table.main').css({background: '#ffffff'});
    }
} else {
    if ($('.frame .slidee').find('.table').length > 2) {
        $('.table-next, .scrollbar').show(0);
        $('.table.main').css({background: ''});
        $('.frame').sly(slyOption, {
            load: function () {
                $('.slidee').width($('.slidee').width() + 2);
            }
        });
    } else {
        $('.table-next, .scrollbar').hide(0);
        $('.table.main').css({background: '#ffffff'});
    }
}

$(window).resize(function (e) {
    $('.frame').sly('reload');
    $('.table-frame').find('.frame').height($('.table-frame').find('.table.main').height());
});


// WEBPACK FOOTER //
// ./css/bem/table/_table.js